import setServiceDocketServiceNoteConfig from './operations/setServiceDocketServiceNote';
import createTicketConfig from './operations/createTicket';
import updateTicketPhotosConfig from './operations/updateTicketPhotos';
import confirmStockLevelsConfig from './operations/confirmStockLevels';
import confirmMachineValuesConfig from './operations/confirmMachineValues';
import confirmMyDayStepConfig from './operations/confirmMyDayStep';
import createMediaConfig from './operations/createMedia';
import manualRestockConfig from './operations/manualRestock';
import submitChecklistConfig from './operations/submitChecklist';
import warehousePrintJobConfig from './operations/warehousePrintJob';
import reportIncorrectStockSettingConfig from './operations/reportIncorrectStockSetting';
import { clearCouldNotCompleteConfig, markCouldNotCompleteConfig } from './operations/couldNotComplete';

const offlineOperationConfigs = {
	setServiceDocketServiceNote: setServiceDocketServiceNoteConfig,
	createTicket: createTicketConfig,
	updateTicketPhotos: updateTicketPhotosConfig,
	confirmStockLevels: confirmStockLevelsConfig,
	confirmMachineValues: confirmMachineValuesConfig,
	confirmMyDayStep: confirmMyDayStepConfig,
	createMedia: createMediaConfig,
	manualRestock: manualRestockConfig,
	submitChecklist: submitChecklistConfig,
	warehousePrintJob: warehousePrintJobConfig,
	reportIncorrectStockSetting: reportIncorrectStockSettingConfig,
	markServiceDocketCouldNotComplete: markCouldNotCompleteConfig,
	clearServiceDocketCouldNotComplete: clearCouldNotCompleteConfig,
};

export default offlineOperationConfigs;
